import RefreshTokenRequestModelBase from '../_generated/modelBases/refresh-token-request-model-base';

export default class RefreshTokenRequestModel extends RefreshTokenRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
